// mattermost-config-schema.ts
//
// `mattermost` block of config-schema.ts, split out (06g R5 — config-schema.ts
// crossed the 200-line budget). Same zod shape, same JSON-schema output.
import { z } from "zod";

export const MattermostConfigSchema = z
  .object({
    channel_name: z.string().min(1),
    approvers: z.array(
      z
        .object({
          username: z.string().min(1),
          user_id: z.string().min(1),
        })
        .strict(),
    ),
    persona_mode: z.enum(["role-label", "multi-bot"]).default("role-label"),
    // P19c: the API origin and team. Absent => fall back to
    // `.mattermost/credentials.json` (what `avatar comm connect` writes),
    // which is where these live today. Declared here for the same reason
    // `release.gitlab_base_url` was added in P18: a self-hosted Mattermost
    // whose API origin differs from the credentials file had no way to be
    // stated at all.
    base_url: z.string().min(1).optional(),
    team_id: z.string().min(1).optional(),
  })
  .strict();
